module.exports = __webpack_public_path__ + "static/media/carousel-2.be11da1e.jpg";